<template>
  <div class="header" id="header">
    <div @click="back" class="back">
      <i class="iconfont">&#xe604;</i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsHeader',
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped>
.header{ display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f2f2f2; padding: 10px 15px;}
.back a{ text-decoration: none; color: #333;}
.back .iconfont{ font-size: 25px;}
.search-font button{ color: #9f9e9e; border: 0; background: transparent; font-family: Arial,"Microsoft YaHei";}
.search-box{ display: flex; justify-content: space-around; background-color: #efefef; border-radius: 3px;}
.search input{ width: 240px; border: 0; border-radius: 3px; background-color: #efefef;}
input::-webkit-input-placeholder{ color:#7f7f7f; font-size: 13px; line-height: 15px; font-family: Arial,"Microsoft YaHei";}
.search .iconfont{ line-height: 32px; margin: 0 8px; font-size: 14px;}
.back{ width: 7%;}
.search{ width: 78%;}
.search-font{ width: 9%;}
</style>



// WEBPACK FOOTER //
// src/pages/goods/components/Header.vue